import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IEslestirmeOld_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IEslestirmeOld_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  isWeb: boolean;
  isWeb_dummy: boolean;
  GetProductWithCode: any[];
  GetProductWithCode_dummy: any[];
  ScanBarcode: string;
  ScanBarcode_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  GetBoxDetailForMobile: any[];
  GetBoxDetailForMobile_dummy: any[];
  GetOrdersWithBoxId: any[];
  GetOrdersWithBoxId_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  Notify: boolean;
  Notify_dummy: boolean;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  ParseScanInput: any;
  ParseScanInput_dummy: any;
  Divide: number;
  Divide_dummy: number;
  isComp729035Visible: "visible" | "hidden";
  isComp23726Visible: "visible" | "hidden";
  isComp879050Visible: "visible" | "hidden";
  isComp722915Visible: "visible" | "hidden";
  isComp443240Visible: "visible" | "hidden";
  isComp805721Visible: "visible" | "hidden";
  isComp198736Visible: "visible" | "hidden";
  isComp984178Visible: "visible" | "hidden";
  isComp169456Visible: "visible" | "hidden";
  isComp443240Enabled: "enabled" | "disabled";
  isComp224640Enabled: "enabled" | "disabled";
}

export class EslestirmeOld_ScreenBase extends React.PureComponent<
  IEslestirmeOld_ScreenProps,
  any
> {
  eslestirmeold_823519_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "9eff4fe8-574b-4a79-9601-8cb14000273f",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 554865, PropertyName: "value", Value: "Kutu Bilgileri" },
        { Id: 722915, PropertyName: "label", Value: "Kutu Okut" },
        { Id: 883207, PropertyName: "value", Value: "Kutu ID" },
        { Id: 638995, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 161778, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 502417, PropertyName: "value", Value: "Beklenen Adet" },
        { Id: 168440, PropertyName: "value", Value: "Müşteri" },
        { Id: 987806, PropertyName: "value", Value: "Malzeme Bilgisi" },
        { Id: 443240, PropertyName: "label", Value: "Malzeme Okut" },
        { Id: 876722, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 729650, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 106056, PropertyName: "value", Value: "Malzeme Adeti" },
        {
          Id: 255232,
          PropertyName: "value",
          Value: "BU MALZEMEDEN KOYULMASI GEREKEN ADET",
        },
        {
          Id: 765059,
          PropertyName: "label",
          Value: "Teslim Tesellümü Tamamla",
        },
        { Id: 224640, PropertyName: "placeholder", Value: "15" },
        { Id: 805721, PropertyName: "label", Value: "Kutu Ara" },
        { Id: 591837, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 198736, PropertyName: "label", Value: "Malzeme Okut" },
        { Id: 784237, PropertyName: "title", Value: "Kutu ID" },
        {
          Id: 173786,
          PropertyName: "value",
          Value: "[datafield:boxidentifier]",
        },
        { Id: 119468, PropertyName: "title", Value: "Ürün Adı" },
        { Id: 164989, PropertyName: "value", Value: "[datafield:productname]" },
        { Id: 488641, PropertyName: "title", Value: "Sipariş Durumu" },
        { Id: 169456, PropertyName: "value", Value: "Bekliyor" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.eslestirmeold_591837_value_kuikaTextInputRef = React.createRef();
    this.eslestirmeold_823519_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      isWeb: false,
      GetProductWithCode: [],
      ScanBarcode: "",
      SetValueOf: "",
      GetBoxDetailForMobile: [],
      GetOrdersWithBoxId: [],
      IfThenElse: false,
      ParseScanInput: "",
      isComp729035Visible: "hidden",
      isComp23726Visible: "hidden",
      isComp879050Visible: "hidden",
      isComp722915Visible: "hidden",
      isComp443240Visible: "hidden",
      isComp805721Visible: "hidden",
      isComp198736Visible: "hidden",
      isComp984178Visible: "hidden",
      isComp169456Visible: "hidden",
      isComp443240Enabled: "disabled",
      isComp224640Enabled: "disabled",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("eslestirmeold", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.EslestirmeOldPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("eslestirmeold", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["manager"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("eslestirmeold", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.EslestirmeOldPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      eslestirmeold_224640_value: undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  EslestirmeOldPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isWeb = await ReactSystemFunctions.isWeb();
    stateVars.isComp722915Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.isWeb),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp443240Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.isWeb),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp805721Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.isWeb),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp198736Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.isWeb),
        true
      ) &&
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.value(
            this,
            stateVars.GetOrdersWithBoxId !== undefined
              ? stateVars.GetOrdersWithBoxId?.length > 0
                ? stateVars.GetOrdersWithBoxId[0].id
                : null
              : this.state.GetOrdersWithBoxId?.length > 0
              ? this.state.GetOrdersWithBoxId[0].id
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp224640Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.isWeb),
        true
      ) === true
        ? "enabled"
        : "disabled";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EslestirmeOldPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  EslestirmeOldPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      ProductCode_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeOld/EslestirmeOldPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductWithCode = result?.data.getProductWithCode;
    formVars.eslestirmeold_253800_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductWithCode !== undefined
        ? stateVars.GetProductWithCode?.length > 0
          ? stateVars.GetProductWithCode[0].productName
          : null
        : this.state.GetProductWithCode?.length > 0
        ? this.state.GetProductWithCode[0].productName
        : null
    );
    formVars.eslestirmeold_494073_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductWithCode !== undefined
        ? stateVars.GetProductWithCode?.length > 0
          ? stateVars.GetProductWithCode[0].productCode
          : null
        : this.state.GetProductWithCode?.length > 0
        ? this.state.GetProductWithCode[0].productCode
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EslestirmeOldPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeOldPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp722915Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp443240Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp443240Enabled =
      ReactSystemFunctions.isNotEqualTo(
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null,
        null
      ) === true
        ? "enabled"
        : "disabled";
    formVars.eslestirmeold_253800_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductWithCode !== undefined
        ? stateVars.GetProductWithCode?.length > 0
          ? stateVars.GetProductWithCode[0].productName
          : null
        : this.state.GetProductWithCode?.length > 0
        ? this.state.GetProductWithCode[0].productName
        : null
    );

    formVars.eslestirmeold_494073_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductWithCode !== undefined
        ? stateVars.GetProductWithCode?.length > 0
          ? stateVars.GetProductWithCode[0].productCode
          : null
        : this.state.GetProductWithCode?.length > 0
        ? this.state.GetProductWithCode[0].productCode
        : null
    );

    stateVars.isComp224640Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        true
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp805721Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp198736Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        true
      ) &&
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.value(
            this,
            stateVars.GetOrdersWithBoxId !== undefined
              ? stateVars.GetOrdersWithBoxId?.length > 0
                ? stateVars.GetOrdersWithBoxId[0].id
                : null
              : this.state.GetOrdersWithBoxId?.length > 0
              ? this.state.GetOrdersWithBoxId[0].id
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        )) === true
        ? "visible"
        : "hidden";

    stateVars.isComp169456Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "eslestirmeold_823519_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  EslestirmeOldComponent_722915_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ScanBarcode = await ReactSystemFunctions.scanBarcode();
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "eslestirmeold_224640_value",
        "string"
      ),
      ReactSystemFunctions.toDecimal(this, stateVars.ScanBarcode),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EslestirmeOldComponent_722915_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  EslestirmeOldComponent_722915_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxIdentifier_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeold_224640_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      BoxIdentifier_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeold_224640_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeOld/EslestirmeOldComponent_722915_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetBoxDetailForMobile = result?.data.getBoxDetailForMobile;
    formVars.eslestirmeold_177886_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].boxIdentifier
        : null
    );
    formVars.eslestirmeold_772361_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productName
        : null
    );
    formVars.eslestirmeold_255624_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productCode
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productCode
        : null
    );
    formVars.eslestirmeold_804984_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].expectedQuantity
        : null
    );
    formVars.eslestirmeold_6107_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].customerName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].customerName
        : null
    );
    stateVars.isComp443240Enabled =
      ReactSystemFunctions.isNotEqualTo(
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null,
        null
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.GetOrdersWithBoxId = result?.data.getOrdersWithBoxId;

    stateVars.isComp198736Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        true
      ) &&
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.value(
            this,
            stateVars.GetOrdersWithBoxId !== undefined
              ? stateVars.GetOrdersWithBoxId?.length > 0
                ? stateVars.GetOrdersWithBoxId[0].id
                : null
              : this.state.GetOrdersWithBoxId?.length > 0
              ? this.state.GetOrdersWithBoxId[0].id
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        )) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EslestirmeOldComponent_722915_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeOldComponent_722915_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeOldComponent_722915_onClick_if21_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  EslestirmeOldComponent_722915_onClick_if2f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp729035Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_722915_onClick_if2e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "5e0180d9_7d47_a673_d4b2_1dde439d847b_notify",
        this.defaultML,
        "Kutuya ait sipariş bulunamadı!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_722915_onClick_if21_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithBoxId !== undefined
            ? stateVars.GetOrdersWithBoxId?.length > 0
              ? stateVars.GetOrdersWithBoxId[0].id
              : null
            : this.state.GetOrdersWithBoxId?.length > 0
            ? this.state.GetOrdersWithBoxId[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeOldComponent_722915_onClick_if2f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeOldComponent_722915_onClick_if2e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_722915_onClick_else2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "ceb85ff4_131a_6287_e5e6_9a8f853f0c8f_notify",
        this.defaultML,
        "Kutu Bulunamadı!"
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_722915_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].id
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.EslestirmeOldComponent_722915_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeOldComponent_722915_onClick_else2();
      if (isErrorOccurred) return true;
    }

    formVars.eslestirmeold_177886_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].boxIdentifier
        : null
    );

    formVars.eslestirmeold_772361_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productName
        : null
    );

    formVars.eslestirmeold_255624_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productCode
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productCode
        : null
    );

    formVars.eslestirmeold_804984_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].expectedQuantity
        : null
    );

    formVars.eslestirmeold_6107_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].customerName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].customerName
        : null
    );

    stateVars.dataSource_823519 =
      stateVars.GetOrdersWithBoxId ?? this.state.GetOrdersWithBoxId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_443240_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ScanBarcode = await ReactSystemFunctions.scanBarcode();

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EslestirmeOldComponent_443240_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  EslestirmeOldComponent_443240_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      rawInput_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeOld/EslestirmeOldComponent_443240_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ParseScanInput = result?.data.parseScanInput;
    formVars.eslestirmeold_853642_value = ReactSystemFunctions.toString(
      this,
      stateVars.ParseScanInput?.adet
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EslestirmeOldComponent_443240_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeOldComponent_443240_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ParseScanInput?.urunKod),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeOld/EslestirmeOldComponent_443240_onClick_if2",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductWithCode = result?.data.getProductWithCode;
    formVars.eslestirmeold_253800_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductWithCode !== undefined
        ? stateVars.GetProductWithCode?.length > 0
          ? stateVars.GetProductWithCode[0].productName
          : null
        : this.state.GetProductWithCode?.length > 0
        ? this.state.GetProductWithCode[0].productName
        : null
    );
    formVars.eslestirmeold_494073_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductWithCode !== undefined
        ? stateVars.GetProductWithCode?.length > 0
          ? stateVars.GetProductWithCode[0].productCode
          : null
        : this.state.GetProductWithCode?.length > 0
        ? this.state.GetProductWithCode[0].productCode
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeOldComponent_443240_onClick_if21_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeOldComponent_443240_onClick_if2f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Divide = await ReactSystemFunctions.divide(
      ReactSystemFunctions.value(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      ),
      ReactSystemFunctions.toDouble(this, this.state.ParseScanInput?.adet)
    );
    formVars.eslestirmeold_730261_value = ReactSystemFunctions.toString(
      this,
      stateVars.Divide
    );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp23726Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp879050Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_443240_onClick_if2e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "70b884dd_e613_d63b_4a4e_a4066d6e2a18_notify",
        this.defaultML,
        "Kutuyla ürün eşleşmedi!"
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_443240_onClick_if21_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetProductWithCode !== undefined
            ? stateVars.GetProductWithCode?.length > 0
              ? stateVars.GetProductWithCode[0].productCode
              : null
            : this.state.GetProductWithCode?.length > 0
            ? this.state.GetProductWithCode[0].productCode
            : null
        ),
        ReactSystemFunctions.toString(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].productCode
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].productCode
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeOldComponent_443240_onClick_if2f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeOldComponent_443240_onClick_if2e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_443240_onClick_else2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "558c3fe4_579c_3ea5_ec1b_f4a615087659_notify",
        this.defaultML,
        "Barkod okunmadı!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_443240_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(this, this.state.ParseScanInput?.adet),
        "false"
      )
    ) {
      isErrorOccurred = await this.EslestirmeOldComponent_443240_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeOldComponent_443240_onClick_else2();
      if (isErrorOccurred) return true;
    }

    formVars.eslestirmeold_853642_value = ReactSystemFunctions.toString(
      this,
      this.state.ParseScanInput?.adet
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_765059_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxIdentifier_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeold_224640_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeOld/EslestirmeOldComponent_765059_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetBoxDetailForMobile = result?.data.getBoxDetailForMobile;
    formVars.eslestirmeold_177886_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].boxIdentifier
        : null
    );
    formVars.eslestirmeold_772361_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productName
        : null
    );
    formVars.eslestirmeold_255624_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productCode
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productCode
        : null
    );
    formVars.eslestirmeold_804984_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].expectedQuantity
        : null
    );
    formVars.eslestirmeold_6107_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].customerName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].customerName
        : null
    );
    stateVars.isComp443240Enabled =
      ReactSystemFunctions.isNotEqualTo(
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null,
        null
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EslestirmeOldComponent_765059_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeOldComponent_765059_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.eslestirmeold_177886_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].boxIdentifier
        : null
    );

    formVars.eslestirmeold_772361_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productName
        : null
    );

    formVars.eslestirmeold_255624_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productCode
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productCode
        : null
    );

    formVars.eslestirmeold_804984_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].expectedQuantity
        : null
    );

    formVars.eslestirmeold_6107_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].customerName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].customerName
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_805721_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxIdentifier_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeold_224640_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      BoxIdentifier_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeold_224640_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeOld/EslestirmeOldComponent_805721_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetBoxDetailForMobile = result?.data.getBoxDetailForMobile;
    formVars.eslestirmeold_177886_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].boxIdentifier
        : null
    );
    formVars.eslestirmeold_772361_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productName
        : null
    );
    formVars.eslestirmeold_255624_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productCode
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productCode
        : null
    );
    formVars.eslestirmeold_804984_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].expectedQuantity
        : null
    );
    formVars.eslestirmeold_6107_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].customerName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].customerName
        : null
    );
    stateVars.isComp443240Enabled =
      ReactSystemFunctions.isNotEqualTo(
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].boxIdentifier
          : null,
        null
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.GetOrdersWithBoxId = result?.data.getOrdersWithBoxId;

    stateVars.isComp198736Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        true
      ) &&
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.value(
            this,
            stateVars.GetOrdersWithBoxId !== undefined
              ? stateVars.GetOrdersWithBoxId?.length > 0
                ? stateVars.GetOrdersWithBoxId[0].id
                : null
              : this.state.GetOrdersWithBoxId?.length > 0
              ? this.state.GetOrdersWithBoxId[0].id
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        )) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EslestirmeOldComponent_805721_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeOldComponent_805721_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeOldComponent_805721_onClick_if11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  EslestirmeOldComponent_805721_onClick_if1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp729035Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_805721_onClick_if1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "543121f9_93ff_ceb9_d11c_e49fcfb311ec_notify",
        this.defaultML,
        "Kutuya ait sipariş bulunamadı!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_805721_onClick_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithBoxId !== undefined
            ? stateVars.GetOrdersWithBoxId?.length > 0
              ? stateVars.GetOrdersWithBoxId[0].id
              : null
            : this.state.GetOrdersWithBoxId?.length > 0
            ? this.state.GetOrdersWithBoxId[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeOldComponent_805721_onClick_if1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeOldComponent_805721_onClick_if1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_805721_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "fc802ee4_99bb_d872_7bfb_61dbef64ae83_notify",
        this.defaultML,
        "Kutu Bulunamadı!"
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_805721_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].id
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.EslestirmeOldComponent_805721_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeOldComponent_805721_onClick_else1();
      if (isErrorOccurred) return true;
    }

    formVars.eslestirmeold_177886_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].boxIdentifier
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].boxIdentifier
        : null
    );

    formVars.eslestirmeold_772361_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productName
        : null
    );

    formVars.eslestirmeold_255624_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].productCode
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].productCode
        : null
    );

    formVars.eslestirmeold_804984_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].expectedQuantity
        : null
    );

    formVars.eslestirmeold_6107_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBoxDetailForMobile !== undefined
        ? stateVars.GetBoxDetailForMobile?.length > 0
          ? stateVars.GetBoxDetailForMobile[0].customerName
          : null
        : this.state.GetBoxDetailForMobile?.length > 0
        ? this.state.GetBoxDetailForMobile[0].customerName
        : null
    );

    stateVars.dataSource_823519 =
      stateVars.GetOrdersWithBoxId ?? this.state.GetOrdersWithBoxId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_198736_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeold_591837_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EslestirmeOld/EslestirmeOldComponent_198736_onClick_if0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductWithCode = result?.data.getProductWithCode;
    formVars.eslestirmeold_253800_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductWithCode !== undefined
        ? stateVars.GetProductWithCode?.length > 0
          ? stateVars.GetProductWithCode[0].productName
          : null
        : this.state.GetProductWithCode?.length > 0
        ? this.state.GetProductWithCode[0].productName
        : null
    );
    formVars.eslestirmeold_494073_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetProductWithCode !== undefined
        ? stateVars.GetProductWithCode?.length > 0
          ? stateVars.GetProductWithCode[0].productCode
          : null
        : this.state.GetProductWithCode?.length > 0
        ? this.state.GetProductWithCode[0].productCode
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EslestirmeOldComponent_198736_onClick_if01_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EslestirmeOldComponent_198736_onClick_if0f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Divide = await ReactSystemFunctions.divide(
      ReactSystemFunctions.value(
        this,
        stateVars.GetBoxDetailForMobile !== undefined
          ? stateVars.GetBoxDetailForMobile?.length > 0
            ? stateVars.GetBoxDetailForMobile[0].expectedQuantity
            : null
          : this.state.GetBoxDetailForMobile?.length > 0
          ? this.state.GetBoxDetailForMobile[0].expectedQuantity
          : null
      ),
      ReactSystemFunctions.toDouble(this, this.state.ParseScanInput?.adet)
    );
    formVars.eslestirmeold_730261_value = ReactSystemFunctions.toString(
      this,
      stateVars.Divide
    );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp23726Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp879050Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_198736_onClick_if0e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp23726Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp879050Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "3a8830f8_b7b9_56bf_9544_6d6ced5f0ca4_notify",
        this.defaultML,
        "Kutuyla ürün eşleşmedi!"
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_198736_onClick_if01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetProductWithCode !== undefined
            ? stateVars.GetProductWithCode?.length > 0
              ? stateVars.GetProductWithCode[0].productCode
              : null
            : this.state.GetProductWithCode?.length > 0
            ? this.state.GetProductWithCode[0].productCode
            : null
        ),
        ReactSystemFunctions.toString(
          this,
          stateVars.GetBoxDetailForMobile !== undefined
            ? stateVars.GetBoxDetailForMobile?.length > 0
              ? stateVars.GetBoxDetailForMobile[0].productCode
              : null
            : this.state.GetBoxDetailForMobile?.length > 0
            ? this.state.GetBoxDetailForMobile[0].productCode
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.EslestirmeOldComponent_198736_onClick_if0f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeOldComponent_198736_onClick_if0e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_198736_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "ee92d4b6_06fe_3a01_acd8_7538f9e62e8b_notify",
        this.defaultML,
        "Malzeme kodu girilmedi!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_198736_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "eslestirmeold_591837_value",
            "value",
            "",
            "",
            ""
          )
        ),
        true
      )
    ) {
      isErrorOccurred = await this.EslestirmeOldComponent_198736_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.EslestirmeOldComponent_198736_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EslestirmeOldComponent_164989_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
